import React, { useState, useEffect } from 'react';
import { Auth, API, graphqlOperation } from 'aws-amplify';
import { listWebPrivateProjects } from '../graphql/queries';
import Card from '../components/MyProjectCard';
import { Link } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import { SimpleSnackbar } from '../components/SnackBar';


const MyProjects = () => {

    const [authenticated, setAuthenticated] = useState(true);
    const [user, setUser] = useState();
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [updateNeeded, setUpdateNeeded] = useState(false);
    const [showSnackBar, setShowSnackBar] = useState(false);
    const [showWarning, setShowWarning] = useState(false);


    useEffect(()=>{

        Auth.currentAuthenticatedUser()
            .then(user => {
                //console.log(user)
                setUser(user.attributes.sub);
                fetchProjects(user.attributes.sub);

            })
            .catch(error => {
                console.log(error);
                setAuthenticated(false);
            }
            )
        
    },[])

    useEffect(()=>{
        if(user) {

            fetchProjects(user);
            setUpdateNeeded(false);
        }

    }, [user, updateNeeded])

    const fetchProjects = async (id) => {

        try {

            let filter = { type: { contains: "PRIVATE_PROJECT" } }

            const projects = await API.graphql(graphqlOperation(listWebPrivateProjects, { creator: id, filter: filter, limit: 400 }))
            setProjects(projects.data.listWebPrivateProjects.items);
            setLoading(false);
            
        }
        catch (error) {
            console.log('error retrieving projects', error)
            setLoading(false);

        }

    }
    
    const renderDeletionSuccessAlert = (msg) => {

        return (
            <SimpleSnackbar message={msg} close={setShowSnackBar} status={true} severity={'success'} duration={6000}></SimpleSnackbar>
        )

    }
    
    const renderWarningAlert = (msg) => {

        return (
            <SimpleSnackbar message={msg} close={setShowWarning} status={true} severity={'warning'} duration={6000}></SimpleSnackbar>
        )

    }

    const displayProjects = () =>{

        if (loading && authenticated) {
            return(<CircularProgress />)
        }

        else if ((projects.length === 0) && authenticated) {
            return (
                <Link style={{ color: 'grey' }} to={{ pathname: '/app/create' }}> < h1>Seems like you do not have any projects yet - try creating your first project!</h1> </Link>)

        }

        else if (projects.length > 0) {

            return (
                projects.map(project => 
                    <Card key={project.type} projectData={project} setLoading={setLoading} updateNeeded={updateNeeded} doUpdate={setUpdateNeeded} setSnackBar={setShowSnackBar} setWarning={setShowWarning} />
                )
            )
        }
        else {
            return (

                <Link style={{ textDecoration: 'none' }} to={{ pathname: '/' }}>
                    <h1 style={{ color: 'grey' }}>To view your projects LOG IN or CREATE ACCOUNT!</h1>

                </Link>)

        }

    }

    return (
        <div style={{ textAlign: "center" }}>
            {showSnackBar && renderDeletionSuccessAlert('Your project was deleted')}
            {showWarning && renderWarningAlert('Your project could not be deleted, try again later.')}

            <div style={{ display: "flex", justifyContent: "center", flexWrap:"wrap", alignItems:"center" }}>
                {displayProjects()}
            </div>

        </div>

    )

}

export default MyProjects;